'use strict';

document.addEventListener('DOMContentLoaded', () => {
  let body = document.body,
    header = {
      scrolled: false,
      lastScrollTop: 0,
      delta: 5,
      threshold: 20,
      element: document.getElementById('header'),
    };

  if (!header.element) {
    return;
  }

  window.addEventListener('scroll', () => {
    if (Math.abs(header.lastScrollTop - window.scrollY) <= header.delta) {
      return;
    }

    let html = document.documentElement,
      height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight,
      );

    if (window.scrollY > header.lastScrollTop && window.scrollY > header.element.getBoundingClientRect().height) {
      header.element.classList.remove('header-down');
      header.element.classList.add('header-up');
    } else if (window.scrollY + window.innerHeight < height) {
      header.element.classList.remove('header-up');
      header.element.classList.add('header-down');
    }

    body.classList.toggle('scrolled', window.scrollY > header.threshold);

    header.lastScrollTop = window.scrollY;
  });

  window.dispatchEvent(new CustomEvent('scroll'));

  header.element.querySelector('.navbar-toggler').addEventListener('click', (event) => {
    event.target.ariaExpanded = event.target.ariaExpanded === 'true' ? 'false' : 'true';

    let navigation = header.element.querySelector('#main-navigation--mobile');

    if (navigation.classList.contains('show')) {
      window.setTimeout(() => {
        navigation.style.display = 'none';
      }, parseFloat(getComputedStyle(navigation)['transitionDuration']) * 1000);
    } else {
      navigation.style.display = 'block';
    }

    window.setTimeout(() => {
      navigation.classList.toggle('show');
    }, 10);
  });

  header.element.querySelectorAll('.js-partner').forEach((element) => {
    let container = header.element.querySelector('.js-selected-partner');

    element.addEventListener('mouseover', () => {
      container.classList.add('dry');
      container.querySelector('.partner-name').innerHTML = element.querySelector('.partner-name').innerHTML;
    });
    element.addEventListener('mouseout', () => {
      container.classList.remove('dry');
      container.querySelector('.partner-name').innerHTML = '';
    });
  });

  document.getElementById('search-modal').addEventListener('shown.bs.modal', (event) => {
    event.target.querySelector('[type="search"]').focus();
  });

  header.element.querySelectorAll('.js-custom-dropdown').forEach((dropdown) => {
    let toggle = dropdown.querySelector('.dropdown-toggle');
    let menu = dropdown.querySelector('.dropdown-menu');

    if (toggle && menu) {
      toggle.addEventListener('click', (event) => {
        if (event.target.href) {
          window.location.href = event.target.href;
        }
      });

      dropdown.addEventListener('mouseenter', () => {
        menu.classList.add('show');
        toggle.setAttribute('aria-expanded', 'true');
      });

      dropdown.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!dropdown.matches(':hover') && !menu.matches(':hover')) {
            menu.classList.remove('show');
            toggle.setAttribute('aria-expanded', 'false');
          }
        }, 100);
      });

      menu.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!dropdown.matches(':hover') && !menu.matches(':hover')) {
            menu.classList.remove('show');
            toggle.setAttribute('aria-expanded', 'false');
          }
        }, 100);
      });
    }
  });

  header.element.querySelector('.js-partner-link')?.addEventListener('click', (event) => {
    window.location.href = window.getComputedStyle(header.element).getPropertyValue('--partner-startpage');
  });

  if (document.cookie) {
    let cookie = document.cookie.split('; ').find(row => row.startsWith('rmvlno='));

    if (cookie) {
      header.element.querySelector('.js-partner.partner--' + cookie.split('=')[1])?.classList.add('active');
    }
  }
});
